import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class StorageService {
    private platformId = inject(PLATFORM_ID);

    get<T>(key: string): T | null {
        if (!isPlatformBrowser(this.platformId)) return null;
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    }

    set(key: string, value: unknown): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }

    remove(key: string): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem(key);
        }
    }
}
